import { produce } from 'immer'
import { cache } from './client'
import type { GetMyReferralCodeQuery } from './generated/graphql'
import {
  GenerateReferralCodeDocument,
  GetMyReferralCodeDocument,
  GetMyReferrerIdDocument,
  GetReferralCodeInfoDocument,
  GetUserReferralLogsDocument,
  SetReferrerDocument,
} from './generated/graphql'
import { createMutationHelper, createQueryHook, modifyQueryHook } from './utils'

export const [useGenerateReferralCode, executeGenerateReferralCode] =
  createMutationHelper(GenerateReferralCodeDocument)
export const useGetMyReferralCode = modifyQueryHook(
  createQueryHook(GetMyReferralCodeDocument),
  {
    reduce: r => r?.me?.referralCode,
  },
)
export const updateGetMyReferralCode = (
  newReferralCode?: NonNullable<GetMyReferralCodeQuery['me']>['referralCode'],
) => {
  cache.updateQuery(
    { query: GetMyReferralCodeDocument },
    produce((data: GetMyReferralCodeQuery | null) => {
      const me = data?.me
      if (me == null) {
        return
      }
      me.referralCode = newReferralCode
    }),
  )
}

export const useGetUserReferralLogs = modifyQueryHook(
  createQueryHook(GetUserReferralLogsDocument),
  {
    reduce: r => r?.referralLogs,
  },
)

export const [useSetReferrer, executeSetReferrer] =
  createMutationHelper(SetReferrerDocument)
export const useGetMyReferrerId = modifyQueryHook(
  createQueryHook(GetMyReferrerIdDocument),
  {
    reduce: r => r?.me?.referrerId,
  },
)

export const useGetReferralCodeInfo = modifyQueryHook(
  createQueryHook(GetReferralCodeInfoDocument),
  {
    reduce: r => r?.referralCode,
  },
)
